import { Tab, Tabs, Typography } from '@material-ui/core';
import { CraApiResponse, EmissaoStatus, GrupoAcesso } from 'common/genericTypes';
import Chip from 'components/chip';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import SuspensaoHistorico, { SuspensaoHistoricoKind } from 'components/suspensaoHistorico';
import { LgSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RootState } from 'store';
import { DetalhesCaracteristicas } from './caracteristicas';
import { DetalhesCriteriosRemuneracao } from './criteriosRemuneracao';
import { DetalhesDocumentos } from './documentos';
import { DetalhesEventosFinanceiros } from 'common/detalhes/eventosFinanceiros';
import { initialCra } from './initialCra';
import Liquidacoes from './liquidacoes';
import Historico from './historico';
import { DetalhesAditamento } from 'pages/instrumentos/detalhes/aditamentos';

type ComponentParams = { craId: string };
type ComponentState = { initialTab?: number };

const mapStateToProps = (state: RootState) => ({
  isUsuarioControlesInternos: state.auth.usuario.grupoAcesso === GrupoAcesso.ControlesInternos,
  isUsuarioOperacoes: state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes,
  craApi: state.craApi,
});

type Props = ReturnType<typeof mapStateToProps> & RouteComponentProps<ComponentParams, {}, ComponentState>;

const DetalhesCra: React.FC<Props> = (props) => {
  const {
    isUsuarioControlesInternos,
    isUsuarioOperacoes,
    craApi: { getCraDetalhes: getCraDetalhesApi },
  } = props;
  const { craId } = props.match.params;

  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [craDetalhes, setCraDetalhes] = useState<CraApiResponse>(initialCra);
  const [loadedDetalhes, setLoadedDetalhes] = useState<Boolean>(false);

  const dispatch = useDispatch();

  const getCraDetalhes = useCallback(async () => {
    try {
      const result = await getCraDetalhesApi(dispatch, craId, true);
      if (result) setCraDetalhes(result);
      setLoadedDetalhes(true);
    } catch (error) {}
  }, [dispatch, getCraDetalhesApi, craId]);

  useEffect(() => {
    getCraDetalhes();
  }, [getCraDetalhes]);

  return (
    <div style={{ marginRight: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h1">
          {'CRA-'}
          {craDetalhes.codigo ?? craDetalhes.ticket}
        </Typography>
        {craDetalhes.suspenso && (
          <Chip
            size="medium"
            label="SUSPENSO"
            color="error"
            style={{
              margin: 20,
            }}
          />
        )}
        {craDetalhes.hasPagamentosInadimplentes && <Chip size="small" label="INADIMPLENTE" color="error" />}
      </div>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Características da Emissão" value={0} />
          <Tab label="Critérios de Remuneração" value={1} />
          <Tab label="Eventos Financeiros" value={2} />
          <Tab label="Documentos" value={3} />
          <Tab label="Aditamentos" value={7} />
          <Tab label="Suspensões" value={4} />
          <Tab label="Histórico" value={5} />
          {(isUsuarioControlesInternos || isUsuarioOperacoes) &&
            craDetalhes &&
            [EmissaoStatus.AguardandoLiquidacao, EmissaoStatus.Emitido, EmissaoStatus.ParcialmenteEmitido].includes(
              craDetalhes.statusEmissao
            ) && <Tab label="Liquidações" value={6} />}
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <DetalhesCaracteristicas caracteristicas={craDetalhes} />}
      {tabValue === 1 && <DetalhesCriteriosRemuneracao criteriosRemuneracao={craDetalhes} />}
      {tabValue === 2 && <DetalhesEventosFinanceiros eventosFinanceiros={craDetalhes} />}
      {tabValue === 3 && <DetalhesDocumentos documentos={craDetalhes} />}
      {tabValue === 4 && (
        <SuspensaoHistorico
          kind={SuspensaoHistoricoKind.InstrumentoFinanceiro}
          registroHistoricos={craDetalhes.registro.registroHistoricos}
        />
      )}
      {tabValue === 5 && <Historico craDetalhes={craDetalhes} />}
      {tabValue === 6 && loadedDetalhes && (
        <Liquidacoes
          onConfirmarLiquidacaoSuccess={getCraDetalhes}
          liquidacaoDireta={craDetalhes.criteriosRemuneracao.liquidacaoDireta}
          aguardandoLiquidacao={craDetalhes.statusEmissao === EmissaoStatus.AguardandoLiquidacao}
          precoUnitarioLiquidacao={craDetalhes.criteriosRemuneracao.precoUnitarioLiquidacao}
          craId={craId}
          instrumentoFinanceiroGuid={craDetalhes.instrumentoFinanceiroGuid}
        />
      )}
      {tabValue === 7 && <DetalhesAditamento documentos={craDetalhes.instrumentoFinanceiroGuid} />}
    </div>
  );
};

export default connect(mapStateToProps)(withRouter(DetalhesCra));
